'use client';

import { useEffect } from 'react';
import { reportBoundaryError } from '@/lib/reportBoundaryError';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
	useEffect(() => {
		reportBoundaryError(error, 'global');
	}, [error]);

	return (
		<html lang="en">
			<body
				style={{
					margin: 0,
					fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
					backgroundColor: '#09090b',
					color: '#fafafa',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					minHeight: '100vh',
				}}
			>
				<div
					style={{
						maxWidth: 420,
						width: '100%',
						padding: 32,
						border: '1px solid rgba(255, 255, 255, 0.1)',
						borderRadius: 12,
						textAlign: 'center',
					}}
				>
					<div style={{ fontSize: 40, marginBottom: 12 }}>&#9888;</div>
					<h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 600 }}>Something went wrong</h2>
					<p style={{ margin: '0 0 20px', fontSize: 14, color: '#a1a1aa' }}>
						A critical error occurred. Our team has been notified.
					</p>
					{error.digest && (
						<p
							style={{
								margin: '0 0 20px',
								fontSize: 12,
								fontFamily: 'monospace',
								color: '#52525b',
							}}
						>
							ref: {error.digest}
						</p>
					)}
					<div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
						<button
							onClick={reset}
							data-pendo="error-boundary:retry"
							style={{
								padding: '8px 16px',
								fontSize: 14,
								fontWeight: 500,
								border: '1px solid rgba(255, 255, 255, 0.1)',
								borderRadius: 6,
								backgroundColor: 'transparent',
								color: '#fafafa',
								cursor: 'pointer',
							}}
						>
							Try again
						</button>
						{/* eslint-disable-next-line @next/next/no-html-link-for-pages -- global-error replaces <html>, no router available */}
						<a
							href="/"
							data-pendo="error-boundary:go-home"
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								padding: '8px 16px',
								fontSize: 14,
								fontWeight: 500,
								border: 'none',
								borderRadius: 6,
								backgroundColor: '#fafafa',
								color: '#09090b',
								textDecoration: 'none',
								cursor: 'pointer',
							}}
						>
							Go home
						</a>
					</div>
				</div>
			</body>
		</html>
	);
}
